import React, {Component} from 'react'
import PropTypes from 'prop-types'
import './style.css'
import ArrowBottom2 from '../../_common/_icons/ArrowBottom2'
import _ from 'lodash'
import {PersonTypeEnum} from "../../../enums/PersonTypeEnum"

const avatarDefault = require('./profile-img.jpg')

class MCProfileMenu extends Component {

    state = {
        menuOpen: false
    }

    toggleMenu = _.debounce(() => this.setState({menuOpen: !this.state.menuOpen}), 200)


    render() {

        console.log(this.props.context)
        const {menuOpen} = this.state

        let isTeacher = false
        let showViewToggler = false
        let person = null

        if(this.props.context !== undefined){

            person = this.props.context.person
            isTeacher = this.props.context.isTeacher
            showViewToggler = (person !== null) ? person.types.split('|').some(type=>type === PersonTypeEnum.TEACHER + '') : false
        }

        const {
            nameProfile,
            avatarProfile,
            onRouteClick,
            style,
            showAccountLink,
        } = this.props

        const popHoverCls = ["pop-hover"]
        if (menuOpen)
            popHoverCls.push('open')

        return (
            <div onClick={this.toggleMenu}>

                <div className='mc-profile-menu' style={style}>

                        <div className="avatar" style={{
                            backgroundImage: `url('${avatarProfile || avatarDefault}')`,
                            backgroundPosition: 'center'
                        }} /><a onClick={() => onRouteClick('account')} className="linkAccount">&nbsp;&nbsp;Meus cursos</a>

                    <div className={popHoverCls.join( ' ' )}>

                        <div className="arrow"/>

                        <h3>{nameProfile}</h3>

                        <ul>
                            {
                                showAccountLink &&
                                <li>
                                    <a onClick={
                                        () => {
                                            if (this.state.menuOpen)
                                                onRouteClick('account')
                                            else
                                                this.toggleMenu()

                                        }}>

                                        <img src={require('./user.svg')} />
                                        Minha conta
                                    </a>
                                </li>
                            }
                            {
                                showViewToggler ? 
                                <li>
                                    <a onClick={
                                        () => {

                                            isTeacher = !isTeacher 
                                            if(showViewToggler){
                                                this.props.context.set({
                                                    isTeacher, 
                                                }, () => {
                                                    onRouteClick('conta')
                                                    window.location.reload()
                                                })
                                            }
                                        }}>
                                        Visualizar como {!isTeacher ? 'instrutor' : 'aluno'}
                                    </a>
                                </li>
                                : ''
                            }
                            <li>
                                <a onClick={
                                    () => {
                                        if (this.state.menuOpen)
                                            onRouteClick('logout')
                                        else
                                            this.toggleMenu()

                                    }}>
                                    <img src={require('./logout.svg')} />
                                    Sair
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}


MCProfileMenu.propTypes = {
    nameProfile: PropTypes.string,
    avatarProfile: PropTypes.string,
    onRouteClick: PropTypes.func,
    showAccountLink: PropTypes.bool ,
}

MCProfileMenu.defaultProps = {
    showAccountLink: false ,
}

export default MCProfileMenu;



// WEBPACK FOOTER //
// ./src/components/_common/ProfileMenu/index.js